import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    CartItems: [],
    isVaild: false,
  },
  getters: {
    isAuth: (state) => {
      return state.isVaild;
    },
    CurrentCart: (state) => {
      return state.CartItems;
    },
    CartCount: (state) => {
      return state.CartItems.length;
    },
  },
  mutations: {
    SET_AUTH: (state, token) => {
      state.isVaild = true;
      sessionStorage.setItem("token", token);
    },
    LOGOUT: (state) => {
      state.isVaild = false;
      state.CartItems = [];
      sessionStorage.clear();
    },
    AddItem(state, item) {
      const tempItem = {
        id: item.id,
        name: item.name,
        description: "",
        qty: item.qty,
      };
      state.CartItems.push(tempItem);
    },
    RemoveItem(state, Pitem) {
      state.CartItems = state.CartItems.filter((item) => item !== Pitem);
    },
    FlushCart(state) {
      state.CartItems = [];
    },
  },
  actions: {
    async login({ commit }, Credential) {
      await Axios({
        method: "post",
        url: "Customer/Login",
        data: JSON.stringify(Credential),
      })
        .then(({ data }) => {
          commit("SET_AUTH", data.data);
          commit("FlushCart");
        })
        .catch(({ message }) => console.log(message));
    },
    AddNewItem({ commit }, item) {
      let found = false;
      this.state.CartItems.forEach((element) => {
        if (element.id === item.id) {
          found = true;
        }
      });
      if (this.state.CartItems.length >= 60) {
        return 2;
      }
      else if (found)
      {
        return 1;
      }
      else if (!found) {
        commit("AddItem", item);
        return 0;
      }
    },
    FlushCurrentCart({ commit }) {
      commit("FlushCart");
    },
    Logout({ commit }) {
      commit("LOGOUT");
    },
    removeitem({ commit }, item) {
      commit("RemoveItem", item);
    },
  },
  modules: {},
});
